export const get_numbers = (input: string): number[] => {
	var ret = input.toString().match(/[0-9]+/g);
	if (ret == null) {
		return [];
	}

	return ret.map(x => parseInt(x));
};